/**
 * Cut-down version of the Metropolis implementation.
 *
 * {@link https://github.com/SEEK-Jobs/metropolis/blob/master/packages/anz-candidate-header-footer/src/legacy-style-guide/react/Logo/Logo.tsx}
 */

import React from 'react';

import { LogoIcon } from './LogoIcon';
import { LogoText } from './LogoText';

const height = 68.031;
const width = 170.079;

interface Props {
  className: string;
}

export const Logo = ({ className }: Props) => (
  <svg
    className={className}
    height={`${height}px`}
    viewBox={`0 0 ${width} ${height}`}
    width={`${width}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <LogoIcon />

    <LogoText />
  </svg>
);
